<template>
  <div>
    <SelectorPanel
      type="methodology"
      text="Our Methodology"
      :disabled="disabled"
      :force-close="forceClose"
      @open="handlePanelOpen"
    >
      <v-container v-if="isOpen" class="pa-0 hyp-methodology-container">
        <v-row dense row>
          <v-col class="px-0 col-3">
            <SelectorPanelHeader
              type="methodology"
              title="Our Methodology"
              @click-close="handleClickClose"
            ></SelectorPanelHeader>

            <MethodologyListing @show-item-details="showItemDetails" />
          </v-col>
          <v-col class="col-9 hyp-methodology-details-container">
            <MethodologyDetails
              v-if="selectedItem"
              :selected-item="selectedItem"
            />
          </v-col>
        </v-row>
      </v-container>
    </SelectorPanel>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

export default {
  name: "MethodologySelector",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
    MethodologyListing: () =>
      import("@/components/methodology/MethodologyListing"),
    MethodologyDetails: () =>
      import("@/components/methodology/MethodologyDetails"),
  },
  data: () => ({
    forceClose: null,
    isOpen: false,
    selectedItem: null,
  }),
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
    handlePanelOpen(open) {
      this.isOpen = open;
      if (open) {
        this.refresh = new Date().toISOString();
      }
    },
    showItemDetails(item) {
      this.selectedItem = item;
    },
  },
};
</script>

<style scoped>
.hyp-methodology-container {
  height: 99vh !important;
  padding: 0 !important;
  width: 1200px;
}
.hyp-methodology-details-container {
  overflow-y: auto;
  height: 98vh !important;
  border-left: 1px solid #e4e4e4;
  padding: 40px;
}
</style>
